import Image from '@stone/ui/image/Image';
import React, { useMemo } from 'react';
const Story = (props) => {
    var _a, _b;
    const emailPresence = props.emailLabel && props.emailLabel;
    const phonePresence = props.phoneLabel && props.phoneNumber;
    const data = useMemo(() => {
        if (props.data || props.custom)
            return Object.assign(Object.assign(Object.assign({}, props), props.data), props === null || props === void 0 ? void 0 : props.custom);
        return Object.assign({}, props);
    }, [props]);
    return (React.createElement("div", { className: "story" },
        React.createElement(Image, { src: (_a = data.image) === null || _a === void 0 ? void 0 : _a.path, srcMobile: (_b = data.imageMobile) === null || _b === void 0 ? void 0 : _b.path, alt: data.imgAlt }),
        React.createElement("div", { className: "story__content" },
            React.createElement("h3", { className: "story__content-title" }, data.title),
            data.typeid === 'component_story' && data.subtitle && React.createElement("p", { className: "story__content-description" }, data.subtitle),
            data.typeid === 'component_story_contacts' && (phonePresence || emailPresence) && (React.createElement("div", { className: "story__content-description" },
                emailPresence && (React.createElement("a", { href: `mailto:${data.emailAddress}` },
                    data.emailLabel,
                    " ",
                    data.emailAddress)),
                phonePresence && (React.createElement("a", { href: `tel:${data.phoneNumber}` },
                    data.phoneLabel,
                    " ",
                    data.phoneNumber))))),
        data.link && data.linkText && (React.createElement("div", { className: "story__link" },
            React.createElement("a", { href: data.link, "aria-label": data.linkA11yText },
                React.createElement("span", { "aria-hidden": !!data.linkA11yText || null }, data.linkText))))));
};
export default Story;
